import EventBus from '@/event-bus'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import { mapGetters } from 'vuex'

export default {
  mixins: [MixinIdeaRoles, MixinAiTemplate],

  mounted () {
    EventBus.$on('toggle-guide', (payLoad) => {
      this.guideVisible = payLoad.active
    })
  },

  data () {
    return {
      guideVisibleFirstTime: false,
      guideVisible: false
    }
  },

  watch: {
    async guideVisible (value) {
      if (value) {
        await this.$router.replace({ path: this.$route.fullPath, query: { infoModalOpen: value } })

        return
      }

      await this.$router.replace({ query: null })
    },

    async guideVisibleFirstTime (value) {
      if (value) {
        await this.$router.replace({ path: this.$route.fullPath, query: { infoModalOpenFirstTime: value } })

        return
      }

      await this.$router.replace({ query: null })
    }
  },

  computed: {
    ...mapGetters('user', [
      'isQuickTourCompleted'
    ]),
    ...mapGetters('idea', ['isIdeaFromTemplate', 'isRoleOwner']),

    guidesMap () {
      return {
        revenueStreamGuide: 'revenueStreamFinancialPlanGuide',
        revenueStreamFinancialPlanGuide: 'revenueStreamGuide',

        startupCostGuide: 'startupCostFinancialPlanGuide',
        startupCostFinancialPlanGuide: 'startupCostGuide',

        staffPayrollGuide: 'staffPayrollFinancialPlanGuide',
        staffPayrollFinancialPlanGuide: 'staffPayrollGuide',

        directCostGuide: 'directCostFinancialPlanGuide',
        directCostFinancialPlanGuide: 'directCostGuide',

        marketingBudgetGuide: 'marketingBudgetFinancialPlanGuide',
        marketingBudgetFinancialPlanGuide: 'marketingBudgetGuide',

        otherOverheadsGuide: 'otherOverheadsFinancialPlanGuide',
        otherOverheadsFinancialPlanGuide: 'otherOverheadsGuide'
      }
    }
  },

  methods: {
    async openGuide (guideStep) {
      if (
        this.$store.state.idea.ideaGuide !== null &&
        !this.$store.state.idea.ideaGuide[guideStep] &&
        this.canEdit
      ) {
        this.completeGuide(guideStep)
        this.guideVisibleFirstTime = true
        EventBus.$emit('open-info-first-time', this.guideVisibleFirstTime)

        if (this.isIdeaFromTemplate) {
          if (guideStep === 'swotAnalysisGuide' || guideStep === 'ideaGuide') {
            this.$store.commit('ui/setLoader', { key: 'aiTemplate', value: true })
          }

          if (!this.$store.state.idea.ideaGuide[this.guidesMap[guideStep]]) {
            await this.generateTemplateItems(guideStep)
            EventBus.$emit('reload')
          }

          if (guideStep === 'ideaGuide') {
            await this.generateIdeaTemplateItems()
          }

          if (guideStep === 'swotAnalysisGuide') {
            await this.generateSwotAnalysisTemplateItems()
          }
        }
      } else {
        this.closeInfoFirstTime()
      }
    },

    openInfo () {
      if (this.guideVisibleFirstTime) {
        this.guideVisibleFirstTime = false

        return
      }
      this.guideVisible = true
    },

    closeInfoFirstTime () {
      this.guideVisibleFirstTime = false
      EventBus.$emit('close-info-first-time-close-btn')
    },

    closeGuide () {
      this.guideVisible = false
      EventBus.$emit('close-guide')
    },

    completeGuide (guideName) {
      this.$http.put('guides/' + this.$store.state.idea.ideaGuide.id, { [guideName]: true })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('idea/setGuide', { guide: response.data.payload.guide })
          }
        }).finally(() => {
          this.loading = false
        })
    },

    openGuideDialog (guideStepDialog) {
      if (this.$store.state.user.guideDialog !== null && !this.$store.state.user.guideDialog[guideStepDialog]) {
        this.completeGuideDialog(guideStepDialog)
        setTimeout(() => {
          this.guideVisible = true
        }, 500)
      }
    },

    completeGuideDialog (guideNameDialog) {
      this.$http.put(
        'guides-dialog/' + this.$store.state.user.guideDialog.id,
        { [guideNameDialog]: true }
      ).then((response) => {
        if (response.status === 200) {
          this.$store.commit('user/setGuideDialog', { guideDialog: response.data.payload.guideDialog })
        }
      }).finally(() => {
        this.loading = false
      })
    },

    async openQuickTour (quickTourName) {
      if (!this.isQuickTourCompleted(quickTourName)) {
        await this.$router.push({ path: this.$route.fullPath, query: { openQuickTour: true } })
        this.quickTourVisible = true
        this.isPageContentVisible = false
        this.completeQuickTour(quickTourName)
      }
    },

    completeQuickTour (quickTourName) {
      this.$http.put('quick-tour', { [quickTourName]: true })
        .then((response) => {
          this.$store.commit('user/setQuickTours', response.data.payload.quickTour.data)
        })
    },

    openTip (tipName) {
      if (this.canEdit && !this.$store.state.idea.tipOpen[tipName]) {
        this.$http.put('tip-open', { [tipName]: true })
          .then((response) => {
            this.$store.commit('idea/setTipOpen', response.data.payload.tipOpen.data)
          })
      }
    }
  }
}
